<template>
  <v-container v-if="auditPeriod">
    <v-app-bar app dark dense color="secondary">
      <v-toolbar-title>
        {{ isCurrent ? $t("audit.user.currentAuditPeriod") : $t("audit.user.auditPeriod", { year: auditPeriod.year }) }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-chip v-if="auditPeriodIsClosed(auditPeriod)" color="green" dark>
        {{
          $t("dashboard.auditPeriod.closed", {
            date: formatDate(auditPeriod.closedAt),
          })
        }}
      </v-chip>
    </v-app-bar>

    <AuditPeriod :user="auditPeriod.user" :audit-period="auditPeriod" />
  </v-container>
</template>

<script>
import AuditPeriod from "@/components/Audit/User/AuditPeriod";
import AuditAuditPeriodQuery from "@/gql/queries/auditor/AuditAuditPeriodQuery.gql";
import auditPeriodIsClosed from "@fng/common/auditPeriodIsClosed";

export default {
  components: {
    AuditPeriod,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      auditPeriod: null,
    };
  },

  apollo: {
    auditPeriod: {
      query: AuditAuditPeriodQuery,
      variables() {
        return {
          id: this.id,
        };
      },
    },
  },

  computed: {
    isCurrent() {
      return this.auditPeriod.year === new Date().getFullYear();
    },
  },

  methods: {
    auditPeriodIsClosed,

    formatDate(val) {
      return new Date(val).toLocaleString(undefined, {
        timeZone: "CET",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
};
</script>
